import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material'
import { Box, Card, CircularProgress, Stack, Typography } from '@mui/material'
import useGetThemeColor from '@/hooks/useGetThemeColor'
import { sortBySortOrder } from '@/utils/field'
import { useWorkflowLiteContext } from './idle-components/WorkflowLiteProvider'

type ProcessingViewProps = {
  stateIds: string[]
}

export default function UpdateStatusCard({ stateIds }: ProcessingViewProps) {
  const getThemeColor = useGetThemeColor()
  const { workflow } = useWorkflowLiteContext()
  const states = sortBySortOrder(
    workflow?.workflow_states?.filter((state) => state.code !== 'processing') ||
      [],
  )
  const currentStateIndex = states.findIndex((state) =>
    stateIds?.includes(state.id),
  )

  return (
    <Card>
      <Stack spacing={0} sx={{ p: 2 }}>
        {states.map((state, index) => {
          const isFirst = index === 0
          const noLines = isFirst || index >= currentStateIndex
          const color = getThemeColor(state.color)

          return (
            <Stack
              key={state.id}
              direction="row"
              spacing={currentStateIndex === index ? 2.25 : 2}
              alignItems="flex-end"
              sx={{ mt: noLines && !isFirst ? '15px' : 0 }}
            >
              <Stack alignItems="center">
                {!noLines && (
                  <Box
                    sx={{
                      height: 15,
                      width: '2px',
                      bgcolor: getThemeColor(states[index - 1].color),
                    }}
                  />
                )}
                {index === currentStateIndex && (
                  <CircularProgress size={20} sx={{ color, ml: 0.25 }} />
                )}
                {index < currentStateIndex && <CheckCircle sx={{ color }} />}
                {index > currentStateIndex && (
                  <RadioButtonUnchecked color="disabled" />
                )}
              </Stack>
              <Typography variant="body2" sx={{ mb: '2px !important' }}>
                {state.name}
              </Typography>
            </Stack>
          )
        })}
      </Stack>
    </Card>
  )
}
